// import React from "react";
// import "./Home.css";
// import homeImage from "./home.jpg";
// import Product from "./Product";
// import pavilion from "./pavilion.jpg"
// import hplatest from "./hplatest.jpg"
// import desktop from "./desktop.jpg"
// import monitor from "./monitor.jpg"
// import security from "./security.jpg"
// import gaming from "./geming.jpg"


// export default function Home() {
//   return (
    // <div className="home">
    //   <div className="home__container">
    //     <img className="home__image" src={homeImage} />
    //     <div className="home__row">
  
  
//           <Product
//             id="12321341"
//             title="TOUCH-SCREEEN ALL-IN-ONE INTEL IRIS CORE i7-16GB MEMORY 1TB SSD-SPARKLING BLACK"
//             price={1399.99}
//             rating={5}
//             image={pavilion}
//           />
//           <Product
//             id="49538094"
//             title="HP OMEN-40L GAMING DESKTOP-AMD RYZEN 7 7700-16GB DDR5 MEMORY-NIVIDIA GEFORCE RTX 4060 TI-1TB SSD-BLACK"
//             price={1900}
//             rating={5}
//             image={gaming}
//           />
        
//         </div>
//         <div className="home__row">
//           <Product
//             id="4903850"
//             title="HP-ENVY DESKTOP-INTEL  CORE i7-32GB MEMORY"
//             price={1399.99}
//             rating={5}
//             image={hplatest}
//           />
//           <Product
//             id="23445930"
//             title="HP-27"
//             IPS
//             LED
//             FHD
//             Freesync
//             price={129.99}
//             rating={5}
//             image={desktop}
//           />
//           <Product
//             id="3254354345"
//             title="LOGITECH-MK540"
//             price={40}
//             rating={5}
//             image={monitor}
//           />
//         </div>
//         <div className="home__row">
//           <Product
//             id="90829332"
//             title="LOGITECH-STREAMCAM 1080 WEBCAM"
//             price={169.99}
//             rating={5}
//             image={security}
//           />
//         </div>
//       </div>
//     </div>
//   );
// }


import React, { useState } from 'react';
import './Home.css';
import Product from "./Product";

// import Product from '../Product'; 

function Home() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const bannerImages = [
"https://m.media-amazon.com/images/W/MEDIAX_792452-T1/images/I/71LeWs1P1JL._SX3000_.jpg",
// "https://m.media-amazon.com/images/W/MEDIAX_792452-T1/images/I/71-xs7rzA-L._SX3000_.jpg",
"https://m.media-amazon.com/images/W/MEDIAX_792452-T1/images/I/61qfJ0kqCwL._SX3000_.jpg",
// "https://m.media-amazon.com/images/W/MEDIAX_792452-T1/images/I/710Q61rv7mL._SX3000_.jpg",
// "https://m.media-amazon.com/images/W/MEDIAX_792452-T1/images/I/71pYMdL5beL._SX3000_.jpg",
// "https://m.media-amazon.com/images/W/MEDIAX_792452-T1/images/I/7191th9dBnL._SX3000_.jpg",
// "https://m.media-amazon.com/images/W/MEDIAX_792452-T1/images/I/61l8uJYskML._SX3000_.jpg",
// "https://m.media-amazon.com/images/W/MEDIAX_792452-T1/images/I/61iRP9L+XtL._SX3000_.jpg",
// "https://m.media-amazon.com/images/W/MEDIAX_792452-T1/images/I/7138lHRi36L._SX3000_.jpg",
"https://m.media-amazon.com/images/W/MEDIAX_792452-T1/images/I/61G25M9YAYL._SX3000_.jpg"


        // Additional banner images can be added here
    ];

    const nextBannerImage = () => {
        setCurrentIndex((currentIndex + 1) % bannerImages.length);
    };

    const prevBannerImage = () => {
        setCurrentIndex((currentIndex - 1 + bannerImages.length) % bannerImages.length);
    };

    return (
        <div className="home">
            <div className="home__container">
                <div className="home__image-container">
                    <button onClick={prevBannerImage} className="home__toggle-button home__toggle-button--left">&#9664;</button>
                    <img
                        className="home__image"
                        src={bannerImages[currentIndex]}
                        alt="Banner"
                    />
                    <button onClick={nextBannerImage} className="home__toggle-button home__toggle-button--right">&#9654;</button>
                </div>

                <div className="home__row">
                <Product 
                  id="202122"
                   title="Discounts on gifts for kids"
                        price={10}
                        rating={5}
                         image="https://images-na.ssl-images-amazon.com/images/G/01/us-manual-merchandising/RBS-in-house-Graphics/Holiday_Toys2_758x608_V1._SY608_CB571659608_.jpg"/>


                    <Product 
                    id="262728"
                    title="Experience the magic of OLED"
                    price={1000}
                     rating={5}
                    image="https://images-na.ssl-images-amazon.com/images/G/01/us-manual-merchandising/RBS-in-house-Graphics/GW_Toys16_758x608._SY608_CB574235264_.jpg"/>
                     
                     <Product 
          id="67890"
          title="Epic deals in sports & outdoors"
          price={200}
          rating={5}
          image="https://images-na.ssl-images-amazon.com/images/G/01/sports/HolidayGG_HP/November/Cat_cards/Skate_NOV_DT_1x._SY304_CB576711483_.jpg"
          image2="https://m.media-amazon.com/images/I/51bLVUn84tL._AC_SY460_.jpg"/>

                    
                    <Product
                        id="49538094"
                        title="Cuisinart Indoor Pizza Oven – Bake 12” Pizzas in Minutes – Portable Countertop Pizza Oven – Stainless Steel - CPZ-120"
                        price={347.99}
                        rating={5}
                        image="https://m.media-amazon.com/images/I/41KfKdcdDbL._AC_SY165_.jpg"
                    />
                </div>
                <div className="home__row">
                    <Product
                        id="4903850"
                        title="ASUS 2023 Vivobook Go 15 Laptop, 15.6” FHD Display, AMD Ryzen 5 7520U Processor, 8GB RAM, 512GB SSD, Windows 11 Home, Mixed Black, E1504FA-AS52"
                        price={369.99}
                        rating={3}
                        image="https://m.media-amazon.com/images/I/41dN7eFrA6L._AC_SY164_.jpg"
                    />
                            <Product 
          id="171819"
          title="Prep for holiday feasts"
          price={10}
          rating={5}
          image="https://images-na.ssl-images-amazon.com/images/G/01/US-hq/2023/img/Consumer_Electronics/XCM_CUTTLE_1647851_3462881_758x608_2X_en_US._SY608_CB576487298_.jpg"/>

                    <Product
                        id="23445930"
                        title="Exclusive Prime member discounts and free shipping on orders of $100 at Amazon Fresh stores."
                        price={98.99}
                        rating={5}
                        image="https://m.media-amazon.com/images/G/01/prime/marketing/slashPrime/Prime_Grocery2x._CB656172610_.png"
                    />
                    <Product
                        id="3254354345"
                        title="New Apple iPad Pro (12.9-inch, Wi-Fi, 128GB) - Silver (4th Generation)"
                        price={598.99}
                        rating={4}
                        image="https://images-na.ssl-images-amazon.com/images/I/816ctt5WV5L._AC_SX385_.jpg"
                    />
                </div>

                <div className="home__row">
                    <Product
                        id="90829332"
                        title="Samsung LC49RG90SSUXEN 49' Curved LED Gaming Monitor - Super Ultra Wide Dual WQHD 5120 x 1440"
                        price={1094.98}
                        rating={4}
                        image="https://images-na.ssl-images-amazon.com/images/I/6125mFrzr6L._AC_SX355_.jpg"

                        
                    />
                </div>
            </div>
        </div>
    );
}
// https://images-na.ssl-images-amazon.com/images/I/6125mFrzr6L._AC_SX355_.jpg
export default Home;
